/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import Sidebar from 'app/components/common/SideBar.jsx';
import { Breakpoint } from 'react-socks';
import SubaccountProvider from 'app/redux/Providers/SubaccountProvider.jsx';
import { compose } from 'redux';
import ErrorBoundary from 'app/components/common/ErrorBoundary.jsx';
import { Outlet } from 'react-router-dom';
import ComponentWithContext from 'app/components/Routers/ComponentWithContext.jsx';

class People extends React.Component {
	constructor(props) {
		super(props);

		let navItems = [
			{
				iconClass: 'fa fa-user-plus sidebar-icon',
				label: 'Team',
				labelClass: 'sidebar-label',
				link: '/people/team'
			},
            {
				iconClass: 'fa fa-briefcase sidebar-icon',
				label: 'Clients',
				labelClass: 'sidebar-label',
				link: '/people/clients'
			}
		];

		this.state = {
			navItems
		};

	}

	render() {
		let { children, ...otherProps } = this.props;

		return (
			<div>
				<ErrorBoundary level="view" {...this.props}>
					<Breakpoint desktop only>
						<Sidebar navItems={this.state.navItems} />
					</Breakpoint>
					<Outlet context={otherProps}/>
				</ErrorBoundary>
			</div>
		);
	}

};

People.displayName = "People";

const enhance = compose(
	ComponentWithContext,
	SubaccountProvider
);

export default enhance(People);
